import { Recurrence } from '@tableau/self-service-schedules';
import { SelfServiceSchedulePane, SelfServiceSchedulePaneProps, SelfServiceSchedulePaneState } from '@tableau/self-service-schedules/lib/src/components/SelfServiceSchedulePane';
import * as React from 'react';
import { ReactActionDialogBodyProps } from '../../commonInfra/dialogs/ReactActionDialog';

export type PropsForSelfServiceScheduleDialogBody = ReactActionDialogBodyProps<SelfServiceSchedulePaneProps, Recurrence>;

export function SelfServiceScheduleDialogBody(props: PropsForSelfServiceScheduleDialogBody): JSX.Element {
    return <SelfServiceSchedulePane
        recurrenceModel={props.recurrenceModel}
        recurrenceModelChangedCallback={props.updateDialogState}
    />;
}